import React from 'react';
import { IonButton } from '@ionic/react';

// Components
import { ModalComponent } from './../../../components';
import { TransactionSuccessOverlay } from '../../transaction/TransactionSuccessOverlay';

// 3.3 Recibe transactionSummary y renderiza TransactionSuccessOverlay
//     cuando está disponible; cae a urlImage en caso contrario (retrocompatible)
export const SuccessModal = ({
    message,
    subtitle,
    urlImage,
    title,
    handleFinish,
    closeModal,
    textButton,
    transactionSummary
}) => {

    return (
        <>
            <ModalComponent
                message={message}
                subtitle={subtitle}
                title={title}
                closeModal={() => { closeModal(); }}
                urlImage={transactionSummary ? undefined : urlImage}
                svg={transactionSummary
                    ? <TransactionSuccessOverlay
                        benefitType={transactionSummary.benefitType}
                        benefitTitle={transactionSummary.benefitTitle}
                        amount={transactionSummary.amount}
                        discountAmount={transactionSummary.discountAmount}
                        hasCalculableDiscount={transactionSummary.hasCalculableDiscount}
                    />
                    : undefined
                }
            >
                <IonButton
                    type="button"
                    color="primary"
                    shape="round"
                    size="undefined"
                    onClick={handleFinish}>{textButton}</IonButton>

            </ModalComponent>
        </>
    )
}

export default SuccessModal;
